<div class="d-flex flex-column h-100" data-cy="collage-template-container">
  <h3 style="text-align: center" data-cy="collage-template-title">Please select a template</h3>
  <div class="bg-light justify-content-center" fxLayout="row wrap" fxLayoutGap="grid" style="height: 90%;
  display: flex; overflow: scroll" data-cy="collage-template-grid">
      <mat-card appearance="outlined" fxFlex="25%" fxFlex.xs="100%" fxFlex.sm="20%" class="template-tile" disabled (click)="openNameDialog()" data-cy="collage-template-new-card">
        <i class="material-icons" data-cy="collage-template-add-icon">add_circle</i>  Save Current as Template
      </mat-card>
      <mat-card appearance="outlined" fxFlex="25%" fxFlex.xs="100%" fxFlex.sm="20%" *ngFor="let template of templates" class="template-tile" (click)="selectTemplate(template)" data-cy="collage-template-item">
        <div *ngIf="selectedTemplate === template" class="selected-check" data-cy="collage-template-selected-check">
          <mat-icon class="text-success" data-cy="collage-template-check-icon">check_circle</mat-icon>
        </div>
        <mat-card-content (click)="selectTemplate(template)" data-cy="collage-template-content">
          <img *ngIf="template?.TemplateSVGIcon !== null || template?.TemplateSVGIcon !== undefined"
            class="template-img" [src]="template?.TemplateSVGIcon" width="100%" height="auto" data-cy="collage-template-icon" />
          <img *ngIf="template?.TemplateSVGIcon === null || template?.TemplateSVGIcon === undefined"
               class="template-img" src="assets/icons/not-found.svg" width="100%" height="auto" style="padding:20%" data-cy="collage-template-default-icon" />
          <mat-divider inset data-cy="collage-template-divider"></mat-divider>
          <div class="template-label" data-cy="collage-template-name">{{template?.TemplateName}}</div>
        </mat-card-content>
      </mat-card>

  </div>

  <div class="d-flex justify-content-end mt-auto" data-cy="collage-template-actions">
    <div class="mr-auto" data-cy="collage-template-options">
      <mat-checkbox *ngIf="templates.length > 0" (change)="hasMargin = $event.checked" data-cy="collage-template-margin-checkbox">Margins</mat-checkbox>
    </div>

    <div data-cy="collage-template-buttons">
      <button mat-button class="tdox-btn tdox-btn-primary-d mr-2" (click)="cancel()"
              style="width: 125px" data-cy="collage-template-cancel-button">
        Cancel
      </button>
      <button mat-button class="tdox-btn tdox-btn-primary" (click)="applyTemplate()"
              style="width: 125px" data-cy="collage-template-apply-button">
        Apply
      </button>
    </div>
  </div>
</div>


